import { render, staticRenderFns } from "./generalTemplateCategory.vue?vue&type=template&id=4cc3ab62&scoped=true&"
import script from "./generalTemplateCategory.vue?vue&type=script&lang=js&"
export * from "./generalTemplateCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc3ab62",
  null
  
)

export default component.exports